export default {
    site: {
      title: 'ESTABLISHED.',
      home: null,
      projects: null,
      about: null,
      contact: null
    },
  }